export const createArticleSectionSelection = (allTitle) => {
  const allTitleElements = allTitle.map((title, index) => `
      <div class="input input--button">
        <label for="${title}">
          <input type="radio" id="${title}" name="articleActive" value="${title}" ${index == 0 ? 'checked' : ''}>
          <div class="style-background"></div>
          <h6>${title}</h6>
        </label>
      </div>
    `)

  return allTitleElements
}

export const createArticleSizeChart = (articleData) => {
  const sizeChartUnits = articleData.map((sizeChartObject) => sizeChartObject.unit)

  const sizeChartElements = `
    <div class="input input--switch">
      <input type="checkbox" id="SwitchSizeGuideUnit">
      <label for="SwitchSizeGuideUnit"></label>
      <span>${sizeChartUnits[0]}</span>
      <span>${sizeChartUnits[1]}</span>
    </div>
  `

  return sizeChartElements
}